import TabMenu from 'components/Tabs/TabMenu'
import styled from 'styled-components'
import { color } from 'utils'

const RoundedTabMenu = styled(TabMenu)<{ width?: string }>`
  width: auto;
  border: none;
  justify-content: flex-start;
  min-height: 0;

  > div {
    width: ${({ width }) => width || 'auto'};
    height: 100%;
    background: ${color('dark700')};
    border-radius: 0.4rem;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
  }
`

export default RoundedTabMenu
